"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  primary: {
    nmBlue: '#002b49'
  },
  accent: {
    blue: '#0095ff',
    teal: '#00bfe6',
    turquoise: '#00ccbb'
  },
  neutral: {
    white: '#ffffff',
    penny: '#fafcff',
    nickel: '#f2f6fa',
    dime: '#dfe6eb',
    quarter: '#c4d0d9',
    halfDollar: '#7d99ad',
    silverDollar: '#4d6a80',
    black: '#000000'
  },
  system: {
    cta: {
      base: '#126ae5',
      hover: '#006aff',
      active: '#105fcc'
    },
    dark: {
      blue: '#004ab3',
      red: '#dc100d',
      green: '#00803c'
    },
    success: '#00a84f',
    warning: '#ffcc33',
    error: '#ff5242'
  }
};
exports.default = _default;
//# sourceMappingURL=colors.js.map